import * as types from "../ActionType";

const initState = {
    users: [],
    loadingUsers: true
}

const UserReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_USER:
            return { ...state, loadingUsers: true }
        case types.GET_USERS:
            return { ...state, users: action.payload, loadingUsers: false }
        case types.DELETE_USER:
            return { ...state}
        case types.EDIT_USER:
            return { ...state, loadingUsers: true }
        case types.BLOCK_USER:
            return { ...state, loadingUsers: true }
        default:
            return state;
    }
};

export default UserReducer;
